module.exports = __webpack_public_path__ + "static/media/10-11.e7aaaedc.mp3";